import { api } from './client';

export type CertSituacao = 'ok' | 'aviso' | 'critico' | 'vencido' | 'indefinido';

export interface Certificado {
  id: number;
  emitente_id: number;
  nome_arquivo: string;
  cnpj_subject?: string;
  nome_titular?: string;
  data_emissao?: string;
  data_validade?: string;
  thumbprint_sha1?: string;
  ativo?: boolean;
  dias_restantes?: number | null;
  situacao?: CertSituacao;
  validacao_ok?: boolean;
  validacao_status?: string;
  validacao_mensagem?: string;
}

export interface CertificadoDiagnostico {
  emitente_id: number;
  certificado_id?: number | null;
  dias_restantes?: number | null;
  situacao?: CertSituacao | 'nenhum';
  validacao_ok: boolean;
  validacao_status: string;
  validacao_mensagem: string;
}

export interface CertificadoVencendo {
  emitente_id: number;
  cnpj: string;
  razao_social: string;
  nome_arquivo?: string;
  data_validade?: string;
  dias_restantes?: number | null;
  situacao?: CertSituacao;
}

export async function getCertificado(emitenteId: number): Promise<Certificado | null> {
  try {
    const { data } = await api.get<Certificado>(`/emitentes/${emitenteId}/certificado`);
    return data;
  } catch (e) {
    const err = e as { response?: { status?: number } };
    if (err.response?.status === 404) return null;
    throw e;
  }
}

export async function uploadCertificado(
  emitenteId: number,
  file: File,
  senha: string
): Promise<Certificado> {
  const form = new FormData();
  form.append('pfx', file);
  form.append('senha', senha);
  const { data } = await api.post<{ ok: boolean; certificado: Certificado }>(
    `/emitentes/${emitenteId}/certificado`,
    form
  );
  return data.certificado;
}

export async function diagnosticarCertificado(emitenteId: number): Promise<CertificadoDiagnostico> {
  const { data } = await api.get<CertificadoDiagnostico>(`/emitentes/${emitenteId}/certificado/diagnostico`);
  return data;
}

export async function listVencendo(): Promise<CertificadoVencendo[]> {
  try {
    const { data } = await api.get<CertificadoVencendo[]>('/certificados/vencendo');
    return data;
  } catch {
    return [];
  }
}
